import { useLocation, useNavigate } from 'react-router-dom';

export const useRouter = () => {
  const baseNavigate = useNavigate();
  const baseLocation = useLocation();

  const navigate = (path: string) => {
    baseNavigate(path, { state: baseLocation });
  };

  const goBack = () => {
    const isExistState = baseLocation.state && baseLocation.state.pathname;
    if (isExistState) {
      navigate(baseLocation.state.pathname + baseLocation.state.search);
    } else {
      window.history.back();
    }
  };

  return {
    navigate,
    goBack,
  };
};
